import Vue from 'vue';

import Vuex from 'vuex';
import { otlpLoggingService } from '@/services/OtlpLoggingService';
import FormStepComponent from '../../components/navigation/FormStepComponent.vue';
import InitialSettingsComponent from '../../components/settings/InitialSettingsComponent.vue';
import AskapriceStylesComponent from '../../components/styles/AskapriceStylesComponent.vue';
import { store } from '../../store';

Vue.config.productionTip = false;
otlpLoggingService.setupLogging();
Vue.use(Vuex);

new Vue({
  components: {
    'initial-settings': InitialSettingsComponent,
    'form-step-component': FormStepComponent,
    'askaprice-styles': AskapriceStylesComponent
  },
  store
}).$mount('#app');
